export function defineComponents(...components) {
    for (const component of components) {
        component.register();
    }
}
